<template>
    <div class="gradeListTable">
        <table>
                <tbody>
                <tr class="title">
                    <th>序号</th>
                    <th>学期</th>
                    <th>考试</th>
                    <th>总分</th>
                    <th>年级总排名</th>
                    <th>排名升降</th>
                    <th>操作</th>
                </tr>
                <tr  v-for="(value,index) in gradeList" :key="index" >
                    <td>{{index + 1 + (pageData.current-1)*pageData.pageSize}}</td>
                    <td>{{value.gradeName}}</td>
                    <td>{{value.nameName}}</td>
                    <td>{{value.totalScore}}</td>
                    <td>{{value.totalRank}}/{{value.totalPeople}}</td>
                    <td>
                        <div v-if="value.rankRise>0">
                            <img src="@img/xueyezixun/public/icon_rise.png" alt="" style="vertical-align: middle" />
                            <span>{{value.rankRise}}</span>
                        </div>
                        <div v-else-if="value.rankRise<0">
                            <img src="@img/xueyezixun/public/icon_fall.png" alt="" style="vertical-align: middle"  />
                            <span>{{value.rankRise.toString().slice(1)}}</span>
                        </div>
                        <div v-else>
                            <span>--</span>
                        </div>
                    </td>
                    <td class="btn goView" @click="goDetail(value.id)">
                        查看
                    </td>
                </tr>
                </tbody>
            </table>
    </div>
</template>
<script>
export default {
    name: "competitionList",
    props: ['gradeList','userType','pageData'],
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
        goDetail(id) {
            if(this.userType==1) {
                this.$router.push({path:'/studyPlan/studentMessage/grade/detail',query:{id: id}})
            }
            if(this.userType==2) {
                this.$router.push({path:'/parent/main/studentMessage/grade/detail',query:{id: id}})
            }
            if(this.userType==3) {
                this.$router.push({path:'/consultant/minestudent/main/studentMessage/grade/detail',query:{id: id}})
            }
        }
    }

}
</script>

<style scoped lang="less">
.gradeListTable {
    table {
        width: 100%;
        th {
            text-align: center;
        }
        tr.title {
            //background: #F0F9FE !important;
            background: rgba(61, 144, 246, 0.2);
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
        tr {
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ECECEC !important;
            .goView {
                color: #0095EB;
                cursor: pointer;
            }
            th {
                font-weight: bold;
            }
        }
    }
}
</style>